import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import { gql } from '@apollo/client';
import { UserFragment } from '../../graphql/fragments/UserFragment';
export var candidateById = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  query candidateById($id: ID!) {\n    candidateById(\n      id: $id\n    ) {\n      ...UserFragment\n    }\n  }\n  ", "\n"])), UserFragment);